/* Boboné price range slider — progressive enhancement over Dawn's price facet.
   Turns the "De / A" number fields into a draggable two-handle bar ("bolitas"),
   keeps the real inputs in sync (so Dawn's AJAX filtering still fires), and
   re-inits whenever the facets markup is replaced. If JS fails, the plain
   number fields remain usable.  [CB 2026-07-29] */
(function () {
  var money = function (n) { return '$' + Math.round(n).toLocaleString('es-MX'); };
  var num = function (v) { return parseFloat(String(v).replace(/[^\d.]/g, '')) || 0; };

  function build(range) {
    if (range.dataset.bsInit === '1') return;
    var inputs = range.querySelectorAll('input[name*="price"]');
    if (inputs.length < 2) return;
    var gte = inputs[0], lte = inputs[1];
    var max = num(gte.dataset.max) || num(lte.dataset.max);
    if (!max) return;
    range.dataset.bsInit = '1';
    range.classList.add('bobone-has-slider');

    var ui = document.createElement('div');
    ui.className = 'bobone-price-slider';
    ui.innerHTML =
      '<div class="bps__track"><div class="bps__fill"></div>' +
      '<button type="button" class="bps__handle" data-h="min" aria-label="Precio mínimo"></button>' +
      '<button type="button" class="bps__handle" data-h="max" aria-label="Precio máximo"></button></div>' +
      '<div class="bps__values"><span class="bps__lo"></span><span class="bps__hi"></span></div>';
    range.insertBefore(ui, range.firstChild);

    var track = ui.querySelector('.bps__track');
    var fill = ui.querySelector('.bps__fill');
    var hMin = ui.querySelector('[data-h="min"]');
    var hMax = ui.querySelector('[data-h="max"]');
    var lo = ui.querySelector('.bps__lo');
    var hi = ui.querySelector('.bps__hi');

    var minV = num(gte.value) || 0;
    var maxV = num(lte.value) || max;

    function render() {
      var a = (minV / max) * 100, b = (maxV / max) * 100;
      hMin.style.left = a + '%'; hMax.style.left = b + '%';
      fill.style.left = a + '%'; fill.style.right = (100 - b) + '%';
      lo.textContent = money(minV); hi.textContent = money(maxV);
    }
    function commit() {
      gte.value = minV > 0 ? Math.round(minV) : '';
      lte.value = maxV < max ? Math.round(maxV) : '';
      [gte, lte].forEach(function (el) {
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    render();

    function drag(handle, which) {
      handle.addEventListener('pointerdown', function (e) {
        e.preventDefault(); handle.setPointerCapture(e.pointerId);
        var rect = track.getBoundingClientRect();
        function move(ev) {
          var pct = Math.min(1, Math.max(0, (ev.clientX - rect.left) / rect.width));
          var val = pct * max;
          if (which === 'min') minV = Math.min(val, maxV);
          else maxV = Math.max(val, minV);
          render();
        }
        function up(ev) {
          handle.releasePointerCapture(e.pointerId);
          handle.removeEventListener('pointermove', move);
          handle.removeEventListener('pointerup', up);
          commit();
        }
        handle.addEventListener('pointermove', move);
        handle.addEventListener('pointerup', up);
      });
      // keyboard a11y
      handle.addEventListener('keydown', function (e) {
        var step = Math.max(10, Math.round(max / 50));
        var d = e.key === 'ArrowRight' ? step : e.key === 'ArrowLeft' ? -step : 0;
        if (!d) return; e.preventDefault();
        if (which === 'min') minV = Math.min(Math.max(0, minV + d), maxV);
        else maxV = Math.max(Math.min(max, maxV + d), minV);
        render(); commit();
      });
    }
    drag(hMin, 'min'); drag(hMax, 'max');
  }

  function initAll(root) {
    (root || document).querySelectorAll('price-range, .facets__price').forEach(build);
  }
  document.addEventListener('DOMContentLoaded', function () { initAll(); });
  // Dawn replaces facet markup on filter → rebuild
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { initAll(); break; }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
